import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep academic content, credentials and component props out of browser logs.
    console.error("MAIKY UI error", {
      name: error?.name || "Error",
      componentStack: info?.componentStack || "",
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="grid min-h-screen place-items-center bg-[#f8f9ff] px-5 py-12" role="alert">
        <section className="play-card w-full max-w-lg bg-rose-50 p-8 text-center sm:p-10" data-testid="app-error-boundary">
          <span className="play-icon mx-auto h-20 w-20 bg-rose-500">
            <AlertTriangle className="h-11 w-11" aria-hidden="true" />
          </span>
          <h1 className="mt-6 font-display text-3xl font-extrabold text-slate-900">Algo se interrumpió</h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            Tu información sigue guardada. Recarga la aplicación para continuar desde el último paso.
          </p>
          <Button className="estudia-touch fun-button mt-6 rounded-2xl bg-rose-600 px-6 font-bold hover:bg-rose-700" onClick={this.handleReload}>
            <RefreshCw className="h-5 w-5" aria-hidden="true" />
            Recargar aplicación
          </Button>
        </section>
      </main>
    );
  }
}
